import { ActionModal, Select } from '@insurancemenu/imenu-components-lib';
import { ModalType } from '@insurancemenu/imenu-components-lib/dist/helpers/ModalsHelper';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTriggerRenewalsPageStore } from 'store/pages/tools/trigger-renewals/pageStore';
import PeriodsModalTable from '../WarningModals/PeriodsModalTable';

const ChangeEffectiveDateModal: React.FC = observer(() => {
  const {
    renewalGroupActionDelegate: { changeEffectiveDateModalDelegate },
  } = useTriggerRenewalsPageStore();
  const {
    isVisible,
    isLoading,
    groupId,
    periodId,
    effectiveDate,
    productLineIds,
    groupName,
    selectedEffectiveDate,
    availableEffectiveDateOptions,
    close,
    save,
    setSelectedEffectiveDate,
  } = changeEffectiveDateModalDelegate;

  return (
    <ActionModal
      show={isVisible}
      loading={isLoading}
      onClose={close}
      onAction={save}
      title="Change renewal effective date"
      subtitle="Choose your desired effective date for this period from the dropdown below."
      actionButtonText="Save"
      modalType={ModalType.NOTIFICATION}
      modalContent={
        <PeriodsModalTable
          periods={[{ id: periodId, groupId, effectiveDate, productLineIds }]}
          groups={[{ id: groupId, name: groupName }]}
          changeableEffectiveDate={
            <Select
              name="renewalEffectiveDate"
              options={availableEffectiveDateOptions}
              onChange={(e: React.ChangeEvent<HTMLSelectElement>): void => {
                setSelectedEffectiveDate(e.target.value);
              }}
              value={selectedEffectiveDate}
              width="auto"
            />
          }
        />
      }
    />
  );
});

export default ChangeEffectiveDateModal;
